import { doc, deleteDoc, updateDoc } from 'firebase/firestore';
import { db, auth } from './config';
import { getAllUsers } from './auth';

// Admin email whitelist
export const ADMIN_EMAILS = [
  'veronika.wannack@gmail.com',
  'josephspenderc@gmail.com'
];

// Check if current user is admin
export const isAdmin = (user) => {
  return user && ADMIN_EMAILS.includes(user.email);
};

// Delete user from Firestore
export const deleteUserFromFirestore = async (userId) => {
  try {
    await deleteDoc(doc(db, 'users', userId));
    return { success: true };
  } catch (error) {
    console.error('Error deleting user:', error);
    return { success: false, error: error.message };
  }
};

// Update user data
export const updateUserData = async (userId, data) => {
  try {
    await updateDoc(doc(db, 'users', userId), data);
    return { success: true };
  } catch (error) {
    console.error('Error updating user:', error);
    return { success: false, error: error.message };
  }
};

// Get all users with admin privileges
export const getAllUsersAsAdmin = async () => {
  try {
    const users = await getAllUsers();
    return { success: true, users };
  } catch (error) {
    console.error('Error getting users:', error);
    return { success: false, error: error.message, users: [] };
  }
};

// Batch update users (e.g., reset avatars)
export const batchUpdateUsers = async (updates) => {
  try {
    const promises = updates.map(({ userId, data }) =>
      updateDoc(doc(db, 'users', userId), data)
    );
    await Promise.all(promises);
    return { success: true, count: updates.length };
  } catch (error) {
    console.error('Error batch updating users:', error);
    return { success: false, error: error.message };
  }
};
